import CoursesPage from "./CoursesPage";
import Layout from "./Layout";

function Index() {
  return (
    <Layout>
      <CoursesPage />
    </Layout>
  );
}

export default Index;